import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { PrivateMediaPlayer } from 'components/privateMediaPlayer';
import Image from 'components/shared/Image/Image';
import { actions } from 'components/shared/attachmentsPreviewModal/actions/attachmentsPreviewModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { AttachedFile } from '../AttachedFile';
import styles from './attachment.module.scss';
const { attachmentsPreviewModalOpen } = actions;
/** The recognized attachment types along with their extensions. */
const EXTENSIONS = {
    image: ['jpg', 'jpeg', 'bmp', 'gif', 'tiff', 'png', 'webp'],
    video: ['mp4', 'm4v', 'mpeg', 'mpg', 'mov', 'avi', 'wmv', 'webm', 'flv'],
    audio: [
        'aac',
        'wav',
        'mp3',
        'aiff',
        'acc',
        'ogg',
        'oga',
        'wma',
        'flac',
        'alac',
    ],
};
/**
 * Gets the attachment type for the attachment.
 *
 * @param attachment The attachment.
 */
export function getAttachmentType(attachment) {
    const filename = attachment.pretty_name || '';
    const extension = filename.substring(filename.lastIndexOf('.') + 1);
    return Object.keys(EXTENSIONS).find((mimeCategory) => EXTENSIONS[mimeCategory].includes(extension));
}
const ImageWrapper = (props) => {
    const dispatch = useAppDispatch();
    const handleImageClick = (src) => {
        if (src) {
            dispatch(attachmentsPreviewModalOpen({
                fileName: 'inlined.jpg',
                url: src,
            }));
        }
    };
    return _jsx(Image, Object.assign({}, props, { onClick: handleImageClick }));
};
function getSingleAttachment(attachment, options) {
    const url = attachment.url;
    const type = getAttachmentType(attachment);
    switch (type) {
        case 'image':
            return (_jsx(ImageWrapper, { wrapperClassName: classnames(styles.imageWrapper, {
                    [styles.scaled]: options === null || options === void 0 ? void 0 : options.scaleImage,
                }), className: classnames(styles.image, {
                    [styles.scaled]: options === null || options === void 0 ? void 0 : options.scaleImage,
                }), src: url, speed: "1", alt: "Image attachment" }));
        case 'video':
        case 'audio':
            return (_jsx(PrivateMediaPlayer, { mediaFile: { src: url, type }, filename: attachment.pretty_name }));
        default:
            return _jsx(AttachedFile, { fileUrl: url, prettyName: attachment.pretty_name });
    }
}
/**
 * Gets the first attachment component based on the attachment type.
 *
 * @param message The message.
 */
export function getAttachment(message, options) {
    if (!message.attached_files) {
        return null;
    }
    const attachment = Array.isArray(message.attached_files)
        ? message.attached_files[0]
        : message.attached_files;
    return getSingleAttachment(attachment, options);
}
/**
 * Gets all the attachment component based on the attachment type.
 *
 * @param message The message.
 */
export function getAttachments(message, options) {
    if (!message.attached_files) {
        return [];
    }
    const attachments = Array.isArray(message.attached_files)
        ? message.attached_files
        : [message.attached_files];
    return attachments.map((attachment) => {
        return getSingleAttachment(attachment, options);
    });
}
